import
  Link
from 'next/link';

interface BreadcrumbItem {
  label: string
  href?: string
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
}

export default function Breadcrumb({
  items
}: BreadcrumbProps) {

  return (
    <nav aria-label="Breadcrumb" className="mb-4 animate-fade-in">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-white/80">
        {items.map((item, i) => {

          const isLast = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-1">
              {item.href && !isLast
                ? (
                  <Link href={item.href} className="hover:text-white transition-colors duration-200">
                    {item.label}
                  </Link>
                )
                : (
                  <span className={isLast ? 'text-white font-semibold' : ''}>{item.label}</span>
                )}
              {!isLast && <span className="text-white/50">»</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
